import Suspense from "components/shared/Suspense";
import { lazy, useRef, useState } from "react";
import BuyBookButtonButton from "./BuyBookButtonButton";
import { Drawer } from "features/Drawer";
import { PageSerializersBooksShow } from "types/serializers";
const BuyBookButtonContent = lazy(() => import("./BuyBookButtonContent"));

export default function BuyBookButton({ book }: { book: PageSerializersBooksShow }) {
  const [open, setOpen] = useState(false);
  const portalRef = useRef<HTMLDivElement>();
  const buyBookButtonRef = useRef<HTMLDivElement>();

  return (
    <div ref={portalRef}>
      <div ref={buyBookButtonRef}>
        <BuyBookButtonButton book={book} onClick={() => setOpen(true)} />
      </div>

      {open && portalRef.current && buyBookButtonRef.current ? (
        <Suspense
          fallback={
            <Drawer.Loading
              settings={{
                portalRef: portalRef.current,
                ref: buyBookButtonRef.current,
                isOpen: true,
                onClose: () => {},
                placement: "bottom",
              }}
            />
          }
        >
          <Drawer
            settings={{
              portalRef: portalRef.current,
              ref: buyBookButtonRef.current,
              isOpen: true,
              onClose: () => setOpen(false),
              placement: "bottom",
            }}
          >
            <BuyBookButtonContent book={book} />
          </Drawer>
        </Suspense>
      ) : (
        false
      )}
    </div>
  );
}
